import React, { ReactNode, useEffect } from 'react';
import { Box } from '@mui/material';
import { useColorMode } from '../../providers/ColorModeProvider';
import { useBackgroundColor } from '../../providers/BackgroundColorProvider';
import Header from '../Header';
// import Footer from '../Footer'; // Footer now integrated into Header menu

interface PublicLayoutProps {
    children: ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
    const { mode } = useColorMode();
    const { backgroundColor } = useBackgroundColor();

    // Apply background color to body element
    useEffect(() => {
        if (backgroundColor) {
            document.body.style.backgroundColor = backgroundColor;
        } else {
            document.body.style.backgroundColor = mode === 'dark' ? '#1a1a1a' : '#faf9f7';
        }
    }, [backgroundColor, mode]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: backgroundColor || (mode === 'dark' ? '#1a1a1a' : '#faf9f7'),
                color: mode === 'dark' ? '#e8dcc6' : '#2c2c2c',
            }}
        >
            <Header />
            <Box
                component="main"
                sx={{
                    backgroundColor: backgroundColor || 'transparent',
                }}
            >
                {children}
            </Box>
            {/* <Footer /> */}
        </Box>
    );
};

export default PublicLayout;